/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import React, { useEffect, useState } from "react";
import { Row, Col } from "antd";
import Zoom from "react-reveal/Zoom";
import { withTranslation } from "react-i18next";
import { useViewport } from "@vlinder-web/viewport-provider-react";
import useForm from "./useForm";
import validate from "./validationRules";

import * as S from "./styles";
import { stubFalse } from "lodash";
import {Block} from "../Block";
import {Button} from "../Button";
import {Input} from "../Input";
import {TextArea} from "../TextArea";

// const Block = lazy(() => import("../Block"));
// const Input = lazy(() => import("../Input"));
// const Button = lazy(() => import("../Button"));
// const TextArea = lazy(() => import("../TextArea"));
// const SelectInput = lazy(() => import("../SelectInput"));

export const Contact = ({
    title,
    title1,
    content,
    content2,
    title2,
    title3,
    id,
    t,
    url,
    subject,
    appId,
    action,
    color,
    secondaryColor,
    onFocusColor,
}) => {
    const {
        values,
        errors,
        handleChange,
        handleSubmit,
        shouldSubmit,
        spinner,
    } = useForm(validate, url, subject, appId, action);

    useEffect(() => {
        if (shouldSubmit) {
            document.getElementById("contactform").reset();
        }
    }, [shouldSubmit]);
    const { bp } = useViewport();
    const ValidationType = ({ type }) => {
        const ErrorMessage = errors[type];
        return errors[type] ? (
            <Zoom cascade>
                <S.Span>{ErrorMessage}</S.Span>
            </Zoom>
        ) : (
            <S.Span />
        );
    };

    const _getContactForm = () => {
        return (
            <S.FormGroup
                autoComplete="off"
                id="contactform"
                onSubmit={handleSubmit}
            >
                <Row type="flex" justify="center" align="middle">
                    <Col lg={12} md={12} sm={24}>
                        <Input
                            type="text"
                            name="name"
                            id="Name"
                            placeholder="Your Name"
                            value={values.name || ""}
                            onChange={handleChange}
                        />
                        <ValidationType type="name" />
                    </Col>
                    <Col lg={12} md={12} sm={24}>
                        <Input
                            type="text"
                            name="email"
                            id="Email"
                            placeholder="Your Email"
                            value={values.email || ""}
                            onChange={handleChange}
                        />
                        <ValidationType type="email" />
                    </Col>
                    <Col lg={24} md={24} sm={24}>
                        <TextArea
                            placeholder="Your Message"
                            value={values.message || ""}
                            name="message"
                            id="Message"
                            onChange={handleChange}
                            maxlength={300}
                        />

                        <ValidationType type="message" />
                    </Col>
                </Row>
                <S.ButtonContainer>
                    <Button
                        name="submit"
                        type="submit"
                        color={color}
                        secondaryColor={secondaryColor}
                        onFocusColor={onFocusColor}
                        onLoading={spinner}
                    >
                        {spinner === true ? "Submitting.." : "Submit"}
                    </Button>
                </S.ButtonContainer>
            </S.FormGroup>
        );
    };

    return (
        <S.ContactContainer id={id}>
            <S.Contact>
                <Row justify="center" align="flex-start">
                    <Col lg={12} md={12} sm={12} xs={24}
                        style={{
                            padding:
                                bp === "xs" || bp === "sm" ? "0 5%" : "0px",
                        }}
                    >
                        <Block padding={true} title={title} />
                        <S.SubTitle>{title1}</S.SubTitle>
                        <div dangerouslySetInnerHTML={{ __html: content }} />
                        {/* <p>{content}</p> */}
                        <S.SubTitle>{title2}</S.SubTitle>
                        <div dangerouslySetInnerHTML={{ __html: content2 }} />
                        {/* <p>{title3}</p> */}
                    </Col>
                </Row>
                <Row justify="center" align="middle">
                    {_getContactForm()}
                </Row>
            </S.Contact>
        </S.ContactContainer>
    );
};

// export default withTranslation()(Contact);
